import { defineMessages } from 'react-intl';

export default defineMessages({
    cancelPromptTitle: {
        id: 'ml.cancellation.common.config.Are you sure you want to cancel?',
        defaultMessage: 'Are you sure you want to cancel?'
    },
    cancelPrompt: {
        id: 'ml.cancellation.common.config.Are you sure you want to withdraw this cancellation?',
        defaultMessage: 'Are you sure you want to withdraw this cancellation?'
    },
    genericErrorMessage: {
        id: 'ml.cancellation.common.config.Something went wrong during this process.',
        defaultMessage: 'Something went wrong during this process.'
    },
    genericErrorTitle: {
        id: 'ml.cancellation.common.config.Error',
        defaultMessage: 'Error'
    },
    withdrawErrorMessage: {
        id: 'ml.cancellation.common.config.An error occurred while attempting to withdraw the cancellation',
        defaultMessage: 'An error occurred while attempting to withdraw the cancellation'
    },
    withdrawErrorTitle: {
        id: 'ml.cancellation.common.config.Unable to withdraw cancellation',
        defaultMessage: 'Unable to withdraw cancellation'
    },
    withdrawing: {
        id: 'ml.cancellation.common.config.Withdrawing cancellation...',
        defaultMessage: 'Withdrawing cancellation...'
    },
});